export default __webpack_public_path__ + "static/media/logoWhite.4b5469cc.svg";